import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { patchQuote } from "../../store/updateQuote/actions";
export var usePatchQuote = function (trigger, body, id) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) {
        var _a;
        return ({
            responsePatchQuote: (_a = state.UpdateQuote.responsePatchQuote) === null || _a === void 0 ? void 0 : _a.data,
            errorPatchQuote: state.UpdateQuote.errorPatchQuote,
            loadingPatchQuote: state.UpdateQuote.loadingPatchQuote,
        });
    }), responsePatchQuote = _a.responsePatchQuote, errorPatchQuote = _a.errorPatchQuote, loadingPatchQuote = _a.loadingPatchQuote;
    useEffect(function () {
        if (trigger) {
            dispatch(patchQuote({ body: body }, id));
        }
    }, [trigger, body === null || body === void 0 ? void 0 : body.planId]);
    return {
        responsePatchQuote: responsePatchQuote,
        errorPatchQuote: errorPatchQuote,
        loadingPatchQuote: loadingPatchQuote,
    };
};
